import { render, staticRenderFns } from "./StretchModal.vue?vue&type=template&id=072be74e&scoped=true"
import script from "./StretchModal.vue?vue&type=script&lang=js"
export * from "./StretchModal.vue?vue&type=script&lang=js"
import style0 from "./StretchModal.vue?vue&type=style&index=0&id=072be74e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072be74e",
  null
  
)

export default component.exports